var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"BCDOverview"}},[_c('BCDList',{attrs:{"bcds":_vm.bcds,"bcd2subnets":_vm.bcd2subnets,"bcd2vlans":_vm.bcd2vlans,"ous":_vm.ous,"bcd2ous":_vm.bcd2ous,"default_sort_by":'name',"bcd2vnis":_vm.bcd2vnis,"netcmpnds_by_name":_vm.netcmpnds_by_name,"netcmpnds_by_net_instnc":_vm.netcmpnds_by_net_instnc}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }